module.exports = {
    startGame: "scattergories - start game",
    endGame: "scattergories - end game",
    setupGame: "scattergories - setup game",
    getAllCategories: "scattergories - get all categories",
    modifyCategories: "scattergories - modify categories"
}